import store from '@/store'

export default class PermissionService {
  public is(role: string): boolean {
    return this.getRoles().some((r) => r.name === role)
  }

  public can(permission: string): boolean {
    if (this.is('Super Admin')) {
      return true
    }

    return (
      this.getRoles().some((r) => r.permissions.includes(permission)) ||
      this.getPermissions().includes(permission)
    )
  }

  private getRoles() {
    return store.state.authenticatedUser
      ? store.state.authenticatedUser.roles
      : []
  }

  private getPermissions() {
    return store.state.authenticatedUser
      ? store.state.authenticatedUser.permissions
      : []
  }
}
